(() => {
const dialog=document.getElementById('AvaPrivacyDialog');
if(!dialog)return;
const form=document.getElementById('AvaPrivacyForm');
const status=document.getElementById('AvaPrivacyStatus');
const save=document.getElementById('AvaPrivacySave');
let mode='cookies';
const apiReady=()=>new Promise((resolve,reject)=>{
if(window.Shopify?.customerPrivacy){resolve(window.Shopify.customerPrivacy);return;}
if(!window.Shopify?.loadFeatures){reject(new Error('Privacy API unavailable'));return;}
window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>error?reject(error):resolve(window.Shopify.customerPrivacy));
});
document.addEventListener('click',async event=>{
const trigger=event.target.closest('[data-ava-privacy]');
if(!trigger)return;
event.preventDefault();
mode=trigger.dataset.avaPrivacy==='choices'?'choices':'cookies';
document.getElementById('AvaPrivacyHeading').textContent=mode==='choices'?'Your Privacy Choices':'Cookie preferences';
document.getElementById('AvaPrivacyIntro').textContent=mode==='choices'?'Manage advertising-related sale or sharing choices for Artist vs Art in this browser.':'Choose which optional categories Artist vs Art may use in this browser.';
dialog.querySelector('[data-ava-cookie-options]').hidden=mode!=='cookies';
dialog.querySelector('[data-ava-sale-options]').hidden=mode!=='choices';
save.disabled=true;
status.textContent='Loading your preferences…';
dialog.showModal();
try{
const api=await apiReady();
const choices=api.currentVisitorConsent();
for(const key of ['preferences','analytics','marketing'])form.elements[key].checked=choices[key]==='yes';
form.elements.opt_out.checked=choices.sale_of_data==='no';
save.disabled=false;
status.textContent='Choose your preferences, then save.';
}catch(error){status.textContent='These controls are unavailable right now. Please email artistvsart@gmail.com for help.';}
});
form.addEventListener('submit',async event=>{
event.preventDefault();
save.disabled=true;
status.textContent='Saving…';
try{
const api=await apiReady();
const choices=mode==='choices'?{sale_of_data:!form.elements.opt_out.checked}:{preferences:form.elements.preferences.checked,analytics:form.elements.analytics.checked,marketing:form.elements.marketing.checked};
api.setTrackingConsent(choices,()=>{
status.textContent='Your choices have been saved for this browser and device.';
save.disabled=false;
});
}catch(error){status.textContent='We could not save your choices. Please email artistvsart@gmail.com for help.';save.disabled=false;}
});
})();